import { ViewIds } from '@ardoq/api-types';
import { AppModules } from 'appContainer/types';
import { param } from 'router/declarative/paramRegistry';
import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';

const isViewId = (value: string): value is ViewIds =>
  Object.values<string>(ViewIds).includes(value);

const viewParam = param<ViewIds | undefined>({
  fromString: value => (isViewId(value) ? value : undefined),
  toString: value => value ?? '',
});

export const routes = {
  path: '/viewpoints',
  title: 'Viewpoints',
  appModule: AppModules.VIEWPOINTS,
  content: async (): PathRouteContent =>
    (await import('../ViewpointsLayout')).ViewpointsLayout,
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('../ViewpointOverview')).ViewpointOverview,
    },
    {
      path: '/default',
      title: 'Default Viewpoints',
      content: async (): PathRouteContent =>
        (await import('../ViewpointDefaults')).ViewpointDefaults,
    },
    {
      path: '/legacy',
      children: [
        {
          path: { index: true },
          content: async (): IndexRouteContent =>
            (await import('../ViewpointOverview')).ViewpointOverview,
        },
        {
          path: '/new',
          title: 'New Viewpoint',
          content: async (): PathRouteContent =>
            (await import('../ViewpointForm')).ViewpointForm,
        },
        {
          path: '/:entityId',
          title: 'Edit Viewpoint',
          content: async (): PathRouteContent =>
            (await import('../ViewpointForm')).ViewpointForm,
        },
      ],
    },
    {
      path: '/view',
      children: [
        { path: { index: true }, redirect: { route: '/viewpoints' } },
        {
          path: '/:loadedState',
          title: 'Open Viewpoint with Loaded State',
          searchParams: { view: viewParam },
          content: async (): PathRouteContent =>
            (await import('../ViewpointMainAppModule')).ViewpointMainAppModule,
        },
      ],
    },
    {
      path: '/:entityId',
      title: 'Open Viewpoint',
      content: async (): PathRouteContent =>
        (await import('../SelectContextPage')).SelectContextPage,
    },
  ],
} as const satisfies RouteNode;
